import { removeAccessToken, removeRefreshToken } from "@/utils/token";

export const logoutMixin = {
  methods: {
    logout() {
      console.log('🔄 Starting logout process...');
      
      // Stop notification service polling if it exists
      if (window.notificationService) {
        console.log('🛑 Stopping notification service...');
        window.notificationService.stopListening();
      }
      
      // Stop any token refresh intervals
      if (window.tokenRefreshInterval) {
        console.log('🛑 Clearing token refresh interval...');
        clearTimeout(window.tokenRefreshInterval);
        window.tokenRefreshInterval = null;
      }
      
      // Clear any other global variables
      if (window.testNotification) {
        delete window.testNotification;
      }
      if (window.clearNotificationCache) {
        delete window.clearNotificationCache;
      }
      
      // Call the clearUser mutation from the store
      this.$store.dispatch("user/clearUser");

      // Clear notification stats
      this.$store.dispatch("notifications/clearNotificationStats");

      // Clear tokens
      removeAccessToken();
      removeRefreshToken();

      // Clear any other stored data
      localStorage.removeItem('processedNotificationIds');
      
      console.log('✅ Logout cleanup completed, redirecting to login...');
      
      // Use hard redirect to stop all background processes
      window.location.href = "/login";
    },
  },
};
